import React from 'react';
import { Handle, Position } from 'reactflow';
import { Square } from 'lucide-react';

interface EndNodeData {
  label?: string;
}

export default function EndNode({ data }: { data: EndNodeData }) {
  return (
    <div className="relative group">
      {/* Connection Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="
          !w-3 !h-3 !border-2
          !bg-accent-red !border-accent-red
          transition-transform hover:scale-125
        "
        style={{ top: '-6px' }}
      />

      {/* Main node body */}
      <div className="
        w-12 h-12 rounded-full
        bg-accent-red/20 dark:bg-accent-red/30
        border-2 border-accent-red
        shadow-md hover:shadow-lg
        transition-all duration-fast
        flex items-center justify-center
      ">
        <Square className="w-4 h-4 text-accent-red fill-current" />
      </div>

      {/* Label */}
      <div className="
        absolute -bottom-5 left-1/2 -translate-x-1/2
        text-[10px] font-medium
        text-muted-foreground
        whitespace-nowrap
      ">
        {data.label || 'END'}
      </div>
    </div>
  );
}

